import { useEffect, useState, useContext } from "react";
import { Box } from "@chakra-ui/react";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { useSession } from "next-auth/client";
import { useRouter } from "next/dist/client/router";
import SearchBar from "components/search-bar";
import Tweets from "components/tweets";
import ProtectedRoute from "components/protected-route";
import { getHooks } from "../controllers/search";
import { Page } from "components/page";
import { MainContext } from "../context/mainContext";
import { getAccount } from "../utils/sessionHelper";
import { Bolt } from "components/icons/Bolt";

export default function Hook() {
  const [session, loading] = useSession();
  const [isSending, setIsSending] = useState(false);
  const [data, setData] = useState<any>(null);
  const [hooks, setHooks] = useState<any>([]);
  const [hasFetched, setHasfetched] = useState<boolean>(false);
  const mainContext = useContext(MainContext);
  const router = useRouter();

  useEffect(() => {
    const { from, idea } = router.query;
    if (session && !hasFetched && from && idea) {
      setHasfetched(true);
      sendRequest(session, idea);
    }
  }, [session]);

  const sendRequest = async (session, topic) => {
    if (isSending) return;

    setIsSending(true);

    let params: any = {
      topic: topic,
      count: 3,
      description: getAccount(session)?.description,
    };

    //@ts-ignore
    let data = await getHooks(session, params, mainContext);

    if (!data || (data.success === 0 && !data?.data?.hooks)) {
      setHooks(null);
    } else {
      let newHooks: any = [];
      data.data.hooks.forEach((hook) => {
        let tw = {
          full_text: hook,
          user: {
            //@ts-ignore
            profile_image_url_https: getAccount(session).image,
            name: getAccount(session).name,
            screen_name: getAccount(session).twUserName,
          },
        };
        newHooks.push(tw);
      });

      setHooks(newHooks);
    }

    setIsSending(false);
  };

  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <Page
      title="Hook Generator"
      description="Enter your topic and we will generate Thread Hooks for you."
    >
      <Box mt={6} display="flex" alignItems="flex-start" w="100%">
        <SearchBar
          sendRequest={sendRequest}
          isLoading={isSending}
          placeholder="Best tactics to grow on X"
          isSending={isSending}
          setIsSending={setIsSending}
          setData={setData}
          disableFilters={true}
          searchMode="hooks"
          mt={2}
          size="md"
          showButton={true}
          buttonText={"Generate"}
          buttonLeftIcon={Bolt}
          showLoader={true}
          ai
          aiButton
        />
      </Box>
      {
        //@ts-ignore
        !isSending && hooks && (
          <Box pt={10}>
            <Tweets
              //@ts-ignore
              sendRequest={sendRequest}
              //@ts-ignore
              tweets={hooks}
              //@ts-ignore
              data={data}
              //@ts-ignore
              setData={setData}
              disableBlur={false}
              disableBookmarkButton={true}
              disableRequest={true}
              disableSaveCsv={true}
              disableEmbed={true}
              disableTryAgain={false}
              disableSubMenu={true}
              disableRetweet={true}
              disableLike={true}
              disableUserPopup={true}
              isVariation={true}
            />
          </Box>
        )
      }
    </Page>
  );
}
